// extracted by mini-css-extract-plugin
export var buttons = "_b5-0";
export var buttonsActive = "_b5-h";
export var cancelConfirm = "_b5-1";
export var closeButton = "_b5-2";
export var column = "_b5-3";
export var container = "_b5-4";
export var detailHeader = "_b5-6";
export var detailTitle = "_b5-7";
export var detailsContent = "_b5-5";
export var header = "_b5-8";
export var headerWithClose = "_b5-9";
export var icon = "_b5-a";
export var infoIcon = "_b5-c";
export var informationContainer = "_b5-b";
export var sideDrawer = "_b5-d";
export var sideDrawerOpen = "_b5-e";
export var stickyFooter = "_b5-f";
export var typeOption = "_b5-g";